<template>
  <div>
    <ui-spinner v-if="loadingView"></ui-spinner>
    <div v-else class="row form-row">
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Nombre *</label>
          <input
            v-model="nombre"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Apellido Paterno *</label>
          <input
            v-model="apPaterno"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Apellido Materno</label>
          <input
            v-model="apMaterno"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Código *</label>
          <input
            v-model="codigo"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Sexo *</label>
          <select v-model="idSexo" class="form-control form-control-sm">
            <option :value="1">Hombre</option>
            <option :value="2">Mujer</option>
          </select>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">DNI</label>
          <input
            v-model="dni"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Usuario</label>
          <input
            v-model="username"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Contraseña</label>
          <input
            v-model="password"
            type="password"
            class="form-control form-control-sm"
          />
          <div class="text-muted font-size-sm">
            Dejar en blanco si no quiere cambiar la contraseña
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Confirmar Contraseña</label>
          <input
            v-model="password_confirmation"
            type="password"
            class="form-control form-control-sm"
          />
          <div class="text-muted font-size-sm">
            Dejar en blanco si no quiere cambiar la contraseña
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Fecha de Nacimiento</label>
          <date-picker
              v-model="fechaNacimiento"
              format="DD-MM-YY"
              value-type="YYYY-MM-DD"
              input-class="form-control form-control-sm"
              :editable="false"
          ></date-picker>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Teléfono 1 *</label>
          <input
            v-model="telefono1"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Teléfono 2</label>
          <input
            v-model="telefono2"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Correo</label>
          <input
            v-model="correo"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Tipo</label>
          <select v-model="idTipo" class="form-control form-control-sm">
            <option
              v-for="item in tiposPersona"
              :key="item.idTipoPersona"
              :value="item.idTipoPersona"
              >{{ item.nombre.toUpperCase() }}</option
            >
          </select>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Idioma</label>
          <select v-model="idIdioma" class="form-control form-control-sm">
            <option
              v-for="item in idiomas"
              :key="item.idIdioma"
              :value="item.idIdioma"
              >{{ item.nombre }}</option
            >
          </select>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Área</label>
          <select v-model="idArea" class="form-control form-control-sm">
            <option
              v-for="item in areas"
              :key="item.idArea"
              :value="item.idArea"
              >{{ item.nombre }}</option
            >
          </select>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Cargo</label>
          <input
            v-model="cargo"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="" class="form-label">Estado *</label>
          <select v-model="idEstado" class="form-control form-control-sm">
            <option :value="0">Inactivo</option>
            <option :value="1">Activo</option>
          </select>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label for="" class="form-label">Imagen</label>
          <ui-input-image
            v-model="imagen"
            :currentImage="currentImage"
          ></ui-input-image>
        </div>
      </div>
      <div class="col-lg-12">
        <!-- <div class="form-group">
          <label for="" class="form-label">Permisos</label>
          <ui-permisos v-model="permisos"></ui-permisos>
        </div> -->
      </div>
    </div>
    <div class="form-group">
      <button
        class="btn btn-sm btn-primary"
        @click="onGuardar"
        :disabled="loading"
      >
        Guardar
      </button>
    </div>
  </div>
</template>
<script>
import UiPermisos from "@/components/Permisos";
import UiInputImage from "@/components/InputImage";
import DatePicker from 'vue2-datepicker';

export default {
  components: {
    UiPermisos,
    UiInputImage,
    DatePicker,
  },
  data: () => ({
    // usuario: null,
    nombre: "",
    apPaterno: "",
    apMaterno: "",
    codigo: "",
    idSexo: 1,
    dni: "",
    username: "",
    password: "",
    password_confirmation: "",
    fechaNacimiento: "",
    telefono1: "",
    telefono2: "",
    correo: "",
    idTipo: "",
    idIdioma: "",
    idArea: "",
    cargo: "",
    currentImage: "",
    imagen: "",
    idEstado: 1,
    permisos: [],
    // containers
    tiposPersona: [],
    areas: [],
    idiomas: [],
    // loaders
    loading: false,
    loadingView: true,
  }),
  async created() {
    const vm = this;
    try {
      let actionURL = "";

      if (vm.$route.params.uuid) {
        actionURL = `/mantenimiento/usuarios/${vm.$route.params.uuid}`;
      } else {
        actionURL = "/mantenimiento/usuarios/nuevo";
      }

      const response = await vm.axios.get(actionURL);

      if (vm.$route.params.uuid) {
        const usuario = response.data.content;
        vm.nombre = usuario.nombre;
        vm.apPaterno = usuario.apPaterno ?? "";
        vm.apMaterno = usuario.apMaterno ?? "";
        vm.codigo = usuario.codigo ?? "";
        vm.idSexo = usuario.idSexo ?? 1;
        vm.dni = usuario.dni ?? "";
        vm.username = usuario.usuario ?? "";
        vm.fechaNacimiento = usuario.fechaNacimiento ?? "";
        vm.telefono1 = usuario.telefono1 ?? "";
        vm.telefono2 = usuario.telefono2 ?? "";
        vm.correo = usuario.correo ?? "";
        vm.idTipo = usuario.idTipo ?? "";
        vm.idIdioma = usuario.idIdioma ?? "";
        vm.idArea = usuario.idArea;
        vm.cargo = usuario.cargo ?? "";
        vm.currentImage = usuario.imagen ?? "";
        vm.idEstado = usuario.idEstado;
        vm.permisos = usuario.permisos ?? [];
        vm.tiposPersona = usuario.tiposPersona ?? [];
        vm.areas = usuario.areas ?? [];
        vm.idiomas = usuario.idiomas ?? [];
      } else {
        vm.tiposPersona = response.data.content.tiposPersona ?? [];
        vm.areas = response.data.content.areas ?? [];
        vm.idiomas = response.data.content.idiomas ?? [];
      }

      vm.loadingView = false;
    } catch (error) {
      console.error(error);
      vm.$router.push({ name: "mantenimiento.usuarios" });
    }
  },
  methods: {
    async onGuardar() {
      const vm = this;
      let usuario = {
        nombre: vm.nombre.trim(),
        apPaterno: vm.apPaterno.trim(),
        apMaterno: vm.apMaterno.trim(),
        codigo: vm.codigo.trim(),
        idSexo: vm.idSexo,
        dni: vm.dni.trim(),
        username: vm.username.trim(),
        password: vm.password.trim(),
        password_confirmation: vm.password_confirmation.trim(),
        fechaNacimiento: vm.fechaNacimiento,
        telefono1: vm.telefono1.trim(),
        telefono2: vm.telefono2.trim(),
        correo: vm.correo.trim(),
        idTipo: vm.idTipo,
        idIdioma: vm.idIdioma,
        idArea: vm.idArea,
        cargo: vm.cargo.trim(),
        imagen: vm.imagen,
        idEstado: vm.idEstado,
        permisos: vm.permisos,
      };

      const camposRequeridos = [
        { id: "nombre", label: "Nombre" },
        { id: "apPaterno", label: "Apellido Paterno" },
        { id: "codigo", label: "Código" },
        { id: "idSexo", label: "Sexo" },
        { id: "telefono1", label: "Teléfono 1" },
        { id: "idEstado", label: "Estado" },
      ];

      if (!vm.$route.params.uuid && usuario.username) {
        camposRequeridos.push(
          ...[
            { id: "password", label: "Contraseña" },
            { id: "password_confirmation", label: "Confirmar contraseña" },
          ]
        );
      }

      const incompletes = vm.$checkIncompletes(camposRequeridos, usuario);

      if (incompletes) {
        return vm.$swal.fire(
          "",
          `Completa los siguientes campos: ${incompletes}`,
          "warning"
        );
      }

      if (
        usuario.password &&
        usuario.password != usuario.password_confirmation
      ) {
        return vm.$swal.fire("", "Las contraseñas no coinciden", "warning");
      }

      vm.loading = true;

      let fd = new FormData();

      fd.append("_method", vm.$route.params.uuid ? "PUT" : "POST");
      fd.append("nombre", usuario.nombre);
      fd.append("apPaterno", usuario.apPaterno);
      fd.append("codigo", usuario.codigo);
      fd.append("idSexo", usuario.idSexo);
      fd.append("telefono1", usuario.telefono1);
      fd.append("idEstado", usuario.idEstado);
      fd.append("permisos", JSON.stringify(usuario.permisos));

      if (usuario.apMaterno) fd.append("apMaterno", usuario.apMaterno);
      if (usuario.dni) fd.append("dni", usuario.dni);
      if (usuario.username) fd.append("username", usuario.username);
      if (usuario.password) fd.append("password", usuario.password);
      if (usuario.password_confirmation)
        fd.append("password_confirmation", usuario.password_confirmation);
      if (usuario.fechaNacimiento)
        fd.append("fechaNacimiento", usuario.fechaNacimiento);
      if (usuario.telefono2) fd.append("telefono2", usuario.telefono2);
      if (usuario.correo) fd.append("correo", usuario.correo);
      if (usuario.idTipo) fd.append("idTipo", usuario.idTipo);
      if (usuario.idIdioma) fd.append("idIdioma", usuario.idIdioma);
      if (usuario.idArea) fd.append("idArea", usuario.idArea);
      if (usuario.cargo) fd.append("cargo", usuario.cargo);

      if (usuario.imagen) fd.append("imagen", usuario.imagen);

      const actionURL = vm.$route.params.uuid
        ? `/mantenimiento/usuarios/${vm.$route.params.uuid}`
        : "/mantenimiento/usuarios";

      vm.axios
        .post(actionURL, fd)
        .then((response) => {
          // if(response.data.content.nuevaImagen) {
          //     vm.registro.currentImage = vm.$storage('/usuarios/perfiles/' + response.data.content.nuevaImagen);
          // }

          vm.$toast.fire(response.data.message, "", "success");
          if (!vm.$route.params.uuid) {
            vm.$router.push({ name: "mantenimiento.usuarios" });
          }
        })
        .finally(() => {
          vm.loading = false;
        });
    },
  },
};
</script>
